import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2D6470",
      d: "M16.607 3.955 13.007.32A1.08 1.08 0 0 0 12.242 0H5.041c-.478 0-.935.192-1.273.533a1.83 1.83 0 0 0-.527 1.285v1.818H1.8c-.478 0-.936.192-1.274.533A1.83 1.83 0 0 0 0 5.455v12.727c0 .482.19.945.527 1.286.338.34.796.532 1.273.532h9.722c.478 0 .935-.192 1.273-.532.338-.341.527-.804.527-1.286v-1.818h1.8c.478 0 .936-.192 1.274-.533.337-.34.527-.803.527-1.285V4.727a1.1 1.1 0 0 0-.316-.772m-5.445 13.863H2.16v-12h6.031l2.971 3zm3.6-3.636h-1.44V8.364a1.1 1.1 0 0 0-.315-.772L9.406 3.955a1.08 1.08 0 0 0-.764-.319H5.4V2.182h6.391l2.97 3zm-5.04-2.546c0 .29-.114.567-.317.772-.202.204-.477.32-.763.32H4.68c-.287 0-.561-.116-.764-.32a1.096 1.096 0 0 1 0-1.543c.203-.205.477-.32.764-.32h3.96c.287 0 .562.115.764.32.203.205.317.482.317.771m0 3.637c0 .29-.114.566-.317.771-.202.205-.477.32-.763.32H4.68c-.287 0-.561-.115-.764-.32a1.096 1.096 0 0 1 0-1.543c.203-.204.477-.32.764-.32h3.96c.287 0 .562.116.764.32.203.205.317.482.317.772"
    }, null, -1)
  ]))]))
}
export default { render: render }